import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Factory, Heart, GraduationCap, Landmark } from "lucide-react";
import { Link } from "react-router-dom";

const UseCases = () => {
  const useCases = [
    {
      icon: <Landmark className="w-8 h-8 text-accent" />,
      title: "Property management",
      description: "Multi-property coding, Yardi-native posting, construction-contractor documentation.",
      link: "/industries/property-management"
    },
    {
      icon: <Heart className="w-8 h-8 text-accent" />,
      title: "Healthcare",
      description: "Vendor credentialing, multi-entity health systems, HIPAA-compliant workflows.",
      link: "/industries/healthcare"
    },
    {
      icon: <GraduationCap className="w-8 h-8 text-accent" />,
      title: "K-12 and higher education",
      description: "Fund accounting, grant tracking, school-year peak volume.",
      link: "/industries/education"
    },
    {
      icon: <Factory className="w-8 h-8 text-accent" />,
      title: "Manufacturing",
      description: "3-way match at high volume, GRN matching, native ERP posting.",
      link: "/industries/manufacturing"
    }
  ];

  return (
    <section className="py-20 bg-section-gradient">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 id="use-cases" className="text-3xl lg:text-5xl font-bold text-foreground mb-6 scroll-mt-32">
            Who uses EZ Cloud
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Mid-market and enterprise finance teams across multiple industries. Each has an integration and a workflow tuned to it.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {useCases.map((useCase, index) => (
            <Link key={index} to={useCase.link} className="block">
              <Card className="border-none shadow-medium hover:shadow-large transition-spring hover:-translate-y-2 bg-white/80 backdrop-blur-sm h-full cursor-pointer">
                <CardHeader>
                  <div className="mb-4">{useCase.icon}</div>
                  <CardTitle className="text-xl font-semibold text-foreground">
                    {useCase.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground leading-relaxed">
                    {useCase.description}
                  </p>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UseCases;